import { last } from 'lodash';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Employee } from '..';
import AbsenceCategories from './AbsenceCategories';
import PersonalData from './PersonalData';
import SalariesCard from './SalariesCard';
import WorkloadCard from './WorkloadCard';
import AdditionalCompensationsCard from './AdditionalCompensationsCard';
import {
  RelatedList,
  mapEmployeeRelatedList,
} from '../../../components/EmployeeData';
import OneTimeComponsationsCard from './OneTimeCompensationsCard';
import { useServerFeature } from '../../../../../hooks/useServerFeature';

type Props = {
  employee: Employee;
};

const Overview: React.FC<Props> = ({ employee }) => {
  const isWorkloadVisible = useServerFeature('Employee_Workload_Details');
  const isSalariesVisible = useServerFeature('Employee_Salaries');

  const currentWorkload = last(employee.currentWorkloads);
  const showWorkload = Boolean(currentWorkload) && isWorkloadVisible;
  const showSalaries = employee.salaries.length > 0 && isSalariesVisible;
  const showAddtionalCompensations =
    isSalariesVisible && employee.additionalCompensations.length > 0;

  const showOneTimeCompensations =
    isSalariesVisible && employee.oneTimeCompensations.length > 0;

  return (
    <Row>
      <Col lg={6}>
        <PersonalData employee={employee} />
      </Col>
      <Col lg={6}>
        {showWorkload && currentWorkload && (
          <WorkloadCard workload={currentWorkload} />
        )}
        {showSalaries && <SalariesCard salaries={employee.salaries} />}
        {showAddtionalCompensations && (
          <AdditionalCompensationsCard
            additionalCompensations={employee.additionalCompensations}
          />
        )}
        {showOneTimeCompensations && (
          <OneTimeComponsationsCard
            oneTimeCompensations={employee.oneTimeCompensations}
          />
        )}
        <AbsenceCategories employee={employee} />
        {employee.data.relatedLists.map((relatedList) => (
          <RelatedList
            key={relatedList.label}
            relatedList={mapEmployeeRelatedList(relatedList)}
          />
        ))}
      </Col>
    </Row>
  );
};

export default Overview;
